import React from 'react'
import { styled } from '@mui/material/styles'
import { useTest } from '@hooks/useTest'
import { useBaseCollectionTileContext } from '../BaseCollectionTileContext'

const RoomOptionsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '4px',
  alignItems: 'center',
  color: theme.palette.secondary.dark,
  fontSize: '14px',
  marginTop: '4px',
  lineHeight: 'normal',
  [theme.breakpoints.up('md')]: {
    fontSize: '16px',
    marginTop: '-4px',
  },
}))

const summaryRoomOptionsConverter = {
  'bed storage': 'Storage',
  'loft bed': 'Loft Bed',
  crib: 'Crib',
  'bunk bed': 'Bunk Bed',
}

// ['Storage'] => 'Storage Options Available'
// ['Storage', 'Loft'] => 'Storage and Loft Options Available'
// ['Storage', 'Loft', 'Crib'] => 'Storage, Loft, and Crib Options Available'
// const formatRoomOptionsSummary = options => {
//   if (!options.length) return ''
//   if (options.length === 1) return `${options[0]} Options Available`
//   if (options.length === 2) return `${options[0]} and ${options[1]} Options Available`
//   return `${options.slice(0, -1).join(', ')} and ${options[options.length - 1]} Options Available`
// }

const RoomOptions = () => {
  const { collection } = useBaseCollectionTileContext()
  const { roomOptions } = collection || {}
  const { generateTestId } = useTest()
  if (!roomOptions || Object.keys(roomOptions).length === 0) return null

  const roomOptionsArray = Object.entries(roomOptions)

  return (
    <RoomOptionsWrapper data-testid={generateTestId('collection-tile', 'room-options')}>
      <span>Options:</span>
      {roomOptionsArray?.map(([option, value], index) => {
        const convertedOption = summaryRoomOptionsConverter[option.toLowerCase()] ?? option

        // Hide the "More Room Options" option
        if (convertedOption === 'More Room Options') return null

        return (
          <React.Fragment key={convertedOption}>
            <span>{convertedOption}</span>
            {index < roomOptionsArray.length - 1 && <span>•</span>}
          </React.Fragment>
        )
      })}
    </RoomOptionsWrapper>
  )
}

export default RoomOptions
